import { Size, SizeConfig } from "../types/publisher";
import { deviceType } from "./enums";

const _loadedScripts:string[] = []
const _loadedPixels:string[] = []


export function cookieStorage(): {has: Function, set: Function, get: Function} {
	return {
		has(key: string) {
			return document.cookie.indexOf(key) !== -1;
		},
		get(key: string) {
			let cookies = document.cookie.split(";");
			for (let i = 0; i < cookies.length; i++) {
				let cookie = cookies[i].split("=");
				if (key == cookie[0].trim()) {
					return JSON.parse(decodeURIComponent(cookie[1]));
				}
			}
			return null;
		},
		set(key: string, value: string, exdays: number = 0) {
			const d = new Date();
			d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
			let expires = "expires=" + d.toUTCString();
			document.cookie = key + "=" + JSON.stringify(value) + ";" + expires + ";path=/";
		}
	}
}

export function cdnPublishersUrl(type: string = '') {
	let baseUrl = cdnUrl(type) + '/mega-publishers'

	let params = (new URL(window.location.toString())).searchParams
	if ((params.has('mega_debug') && ['local'].includes(params.get('mega_debug') ?? '')) || ['local'].includes(type))
		baseUrl = 'http://localhost:3000/src/publishers'

	return baseUrl
}

export function cdnPublishersHashmapUrl(type: string = '') {
	let baseUrl = cdnUrl(type) + '/mega-publishers-hashmap'

	// let params = (new URL(window.location.toString())).searchParams
	// if ((params.has('mega_debug') && ['local'].includes(params.get('mega_debug') ?? '')) || ['local'].includes(type))
	// 	baseUrl = 'http://localhost:3000/src/hashmaps'

	return baseUrl
}
	

export function cdnUrl(type: string = '') {
	let baseUrl = 'https://cdn.aa.onstuimig.nl'

	let params = (new URL(window.location.toString())).searchParams
	if ( (params.has('mega_debug') && ['aws'].includes(params.get('mega_debug')??'')) || ['aws'].includes(type) )
		baseUrl = 'https://d2wvsezglwsyx5.cloudfront.net'

	if ( (params.has('mega_debug') && ['s3'].includes(params.get('mega_debug')??'')) || ['s3'].includes(type) )
		baseUrl = 'https://s3.eu-central-1.amazonaws.com/onstuimig-tag-manager'
	
	if ( (params.has('mega_debug') && ['firebase','fb'].includes(params.get('mega_debug')??'')) || ['firebase','fb'].includes(type) )
		baseUrl = 'https://adfactor-ab52c.firebaseapp.com'

	return baseUrl
}

export function loadJsModule(url: string, callback: Function = ()=>{}, loc: HTMLElement = document.head ): any {
	// already loaded? then call the callback
	if (_loadedScripts.length && _loadedScripts.includes(url)) return callback()

    const scriptTag:any = document.createElement('script');
    scriptTag.module = true;
    scriptTag.src = url;
    scriptTag.onload = callback;
	scriptTag.referrerPolicy = 'strict-origin-when-cross-origin';
    loc.appendChild(scriptTag);
	
	return true;
};

export function loadJs(url: string, callback: Function = ()=>{}, callbackError: Function = ()=>{}, loc: HTMLElement = document.head ): any {
	// already loaded? then call the callback
	if (_loadedScripts.length && _loadedScripts.includes(url)) return callback()

    const scriptTag:any = document.createElement('script');
    scriptTag.src = url;
    scriptTag.onload = callback;
	scriptTag.onerror = callbackError;
	scriptTag.referrerPolicy = 'strict-origin-when-cross-origin';
    loc.appendChild(scriptTag);
	
	return true;
};

export function loadPixel(url: string, callback: Function = ()=>{}, loc: HTMLElement = document.body ): any {
	// already loaded? then call the callback
	if (_loadedPixels.length && _loadedPixels.includes(url)) return callback()

    const scriptTag:any = document.createElement('iframe');
	scriptTag.style.display = 'none';
	scriptTag.src = url;
    scriptTag.onload = callback;
    loc.appendChild(scriptTag);
	
	return true;
};

export async function loadJSON(url: string) {
	const response = await fetch(url);
	
	if(response.ok){
		return await response.json();
	}
}

export function ready(callback: Function = ()=>{}) {
	document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", function () {
        callback();
      })
    : callback();
}

const _firstInteractionEvents:string[] = [
	//'mousemove',
	'scroll',
	'keydown',
	'click',
	'touchstart'
]

export function firstInteraction(callback:Function = ()=>{}) {
	const handler = function():void {
		_firstInteractionEvents.forEach(evt => {
			document.removeEventListener(evt, handler);
		})

		callback()
	}

	_firstInteractionEvents.forEach(event => {
		document.addEventListener(event, handler,
		{once: true}
		)
	})
}

export function log(...params:any) {

	if (window._mega?.publisher?.debug) {
		var args = Array.prototype.slice.call(arguments);
		args.unshift("%cMEGA", "display: inline-block; color: #fff; font-weight: bold; background: #c3416f; padding: 1px 6px; border-radius: 10px;");
        console.log.apply(console, args);
	}
}

export function logError(...params:any) {

	if (window._mega?.publisher?.debug) {
		var args = Array.prototype.slice.call(arguments);
		args.unshift("%cMEGA", "display: inline-block; color: #fff; font-weight: bold; background: #c3416f; padding: 1px 6px; border-radius: 10px;");
        console.error.apply(console, args);
	}
}


let _viewport:any = {}

export function measureViewport(el:HTMLElement = document.body):object {
	if (_viewport && _viewport.height) return _viewport;

	const height:number = getViewportHeight(el)
	const top:number = scrollTop(el)
	const bottom:number = top + height;

	_viewport = { 
		bottom: bottom,
		top: top,
		height: height
	}

	return _viewport;
}

export function elementWidth(element: HTMLElement): number {
	let elementStyles:any = getComputedStyle(element)
	let elementSize:any = measureElement(element)
	
	let elementContentWidth:number = elementSize.width
											- parseFloat(elementStyles.paddingLeft)
											- parseFloat(elementStyles.paddingRight);
	return elementContentWidth
}

export function measureElement(element: HTMLElement): object {

	/* make element visible for a moment and save original properties */
	const originalDisplay: any = element.style.display;
	element.style.display = 'block';

	const originalPosition:any = element.style.position;
	element.style.position = 'relative';
	
	const originalVisibility:any = element.style.visibility;
	element.style.visibility = 'hidden';
	
	/* get rectangle of element */
	const rect:object = element.getBoundingClientRect();

	/* set original properties back */
	element.style.display = originalDisplay;
	element.style.position = originalPosition;
	element.style.visibility = originalVisibility;

	return rect;
}

export function inView(element: HTMLElement): any {
	const viewport: any = measureViewport()
	const position: any = measureElement(element)

	const isBelowViewport: boolean = position.top > viewport.bottom
	const isAboveViewport: boolean = position.bottom < viewport.top
	return isBelowViewport ? 'below' : isAboveViewport ? 'above' : true;
}

function scrollTop(element: HTMLElement) {
    if (element === document.body) {
        return (
            window.pageYOffset ||
            (document.documentElement && document.documentElement.scrollTop) ||
            document.body.scrollTop
        );
    } else {
        return element.scrollTop;
    }
}

function getViewportHeight(element: HTMLElement) {
    if (element === document.body) {
        return window.innerHeight || document.documentElement.clientHeight;
    } else {
        return element.clientHeight;
    }
}


export function css(this: null|HTMLElement, css:string = '') {
	const styles:string = `<style>${css}</style>`

	if ((this instanceof HTMLElement)) {
		this.insertAdjacentHTML("beforebegin", styles)
	} else {
		document.head.insertAdjacentHTML("beforebegin", styles)
	}
}


export async function loadModule(name: string) {
	//await import(/* @vite-ignore */'./node_modules/prebid.js/modules/' + name); 
}

export function isPlainObject(input: unknown): input is Object {
	if (input === null || typeof input !== "object") return false;
	if (Object.getPrototypeOf(input) === null) return true;
	let ref = input;
	while (Object.getPrototypeOf(ref) !== null) ref = Object.getPrototypeOf(ref);
	return Object.getPrototypeOf(input) === ref;
}

export function mergeDeep(target: any, source: any): any {
	let output = Object.assign({}, target);
	if (isPlainObject(target) && isPlainObject(source)) {
		Object.keys(source).forEach(key => {
			if (isPlainObject(source[key])) {
				if (!(key in target)) {
					Object.assign(output, { [key]: source[key] });
				} else {
					output[key] = mergeDeep(target[key], source[key]);
				}
			// } else if (Array.isArray(source[key])) {
			// 	if (!(key in target)) {
			// 		output[key] = source[key];
			// 	} else {
			// 		output[key] = output[key].concat(source[key]);
			// 	}
			} else {
				Object.assign(output, { [key]: source[key] });
			}
		});
	}
	return output;
}

export function isPath(pathList: string[]): boolean {
	const timmedPaths = pathList.map((path) => {
		if(path == '/'){
			return path;
		}
		return path.replace(/\/$/, "");
	});

	let trimmedPath = window.location.pathname;
	if(trimmedPath != '/'){
		trimmedPath = trimmedPath.replace(/\/$/, "");
	}

	return timmedPaths.includes(trimmedPath);
}

export function isHome(homepages: string[]): boolean {
	return isPath(homepages);
}

export function parseSizes(sizes: Size[]|SizeConfig, device: deviceType): Size[] {
	if (Array.isArray(sizes)) {
		return sizes;
	} else {
		return sizes[device] ?? [];
	}
}

export function setSlotProperty(slot:string, prop:string, value:any) {
	if (window._mega?.publisher?.slots) {

	}
}

export function slotKeyToSlotId(slotKey:string) {
	const keyParts = slotKey.split(/(\d+)/, 2);
	const slotType = keyParts[0];

	// Build slot ID
	let slotId = 'ada-'+slotType;
	if(typeof keyParts[1] != 'undefined') {
		slotId += '-'+keyParts[1];
	}

	return slotId
}

export function getDeviceType() {
    if(!window._mega?.publisher) return null;

    const breakpointDesktop = window._mega.publisher.config.breakpointDesktop ?? 990;
	const breakpointTablet = window._mega?.publisher.config.breakpointTablet ?? 768;

	let device: deviceType;
	if (window.innerWidth <= breakpointTablet) { // mobile
		device = deviceType.MOBILE;
	} else if (window.innerWidth <= breakpointDesktop) { // tablet
		device = deviceType.TABLET
	} else { // desktop
		device = deviceType.DESKTOP;
	}

    return device;
}

export function getPageType():string {
	const homepages = window._mega?.publisher?.config.homepages ?? [];

	const customPageType = window._mega?.publisher?.config?.customPageType ?? null;
	let pageType = isHome(homepages) ? 'homepage' : 'artikel';
	if (customPageType) {
		pageType = customPageType;
	}

	return pageType

}